"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const CentralizedLoadingRoot = (0, material_1.styled)("div")({
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
});
exports.default = () => (react_1.default.createElement(CentralizedLoadingRoot, null,
    react_1.default.createElement(material_1.CircularProgress, { color: "secondary" })));
